import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { validateAuthToken } from "@/guards/validateAuthToken";
import { getProviderPostAuthDestination } from "@/lib/providerAccessNavigation";
import { getProviderRegistrationFlowHint } from "@/lib/providerRegistrationFlowHint";
import { store } from "@/app/store";
import { getProvider } from "@/app/store/provider/providerSlice";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: async () => {
    validateAuthToken();

    const flow = getProviderRegistrationFlowHint();

    // Legacy Clinicians keep their existing guards and access behavior.
    // No new entitlement request is made for legacy accounts.
    if (flow === "LEGACY") return;

    if (flow !== "SELF_SERVICE") {
      throw redirect({ to: "/login" });
    }

    const destination = await getProviderPostAuthDestination();

    if (destination !== "/dashboard") {
      throw redirect({ to: destination });
    }

    // Refresh the authenticated clinician's profile before rendering.
    await store.dispatch(getProvider()).unwrap();
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  return <Outlet />;
}
